<template>
  <div class="rBox">
    <!-- <div class="pageTitle">{{ fySelItem.title }}页面</div> -->

    <el-form label-width="150px" label-position="left">
      <div>
        <el-card>
          <div
            v-for="(item, index) in curSelData.zsxx.picList"
            :key="index"
            class="box-card"
            style="margin-top: 10px"
          >
            <div slot="header" class="clearfix">
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="delLunboItem(index)"
                >删除</el-button
              >
            </div>
            <el-form-item label="证书图片">
              <el-col :span="18">
                <el-input v-model="item.url" placeholder="请输入内容图片地址">
                  <template slot="append"
                    ><span
                      style="cursor: pointer"
                      @click="selImg('guoDoctor', 'picList', index)"
                      >选择图片</span
                    ></template
                  >
                </el-input>
              </el-col>
              <el-col :span="18">
                <img height="100px" :src="item.url" alt="" class="imgClass" />
              </el-col>
            </el-form-item>
          </div>
          <el-button
            style="margin: 20px auto; width: 80%; display: block"
            @click="addLunboItem(index)"
            >添加证书</el-button
          >
        </el-card>
      </div>
      <el-form-item label="证书背景图片">
        <el-input v-model="curSelData.certboxBg" placeholder="请输入图片地址">
          <template slot="append"
            ><span
              style="cursor: pointer"
              @click="selImg('guoDoctor', 'certboxBg')"
              >选择图片</span
            ></template
          >
        </el-input>
        <el-col :span="18">
          <img :src="curSelData.certboxBg" alt="" class="imgClass" />
        </el-col>
      </el-form-item>
      <!-- 验证码开始 -->
      <div class="pageTitle pageTitle2">防伪二维码</div>
      <el-form-item label="二维码大小">
        <template>
          <bs-slider v-model="curSelData.scanSize" :min="0" :max="100" />
        </template>
      </el-form-item>
      <el-form-item label="二维码上下边距">
        <template>
          <bs-slider v-model="curSelData.marginTop" :min="0" :max="100" />
        </template>
      </el-form-item>
      <el-form-item label="二维左右边距">
        <template>
          <bs-slider v-model="curSelData.marginLeft" :min="0" :max="100" />
        </template>
      </el-form-item>
      <el-form-item label="二维码标题图片">
        <el-input v-model="curSelData.zsxx.topImg" placeholder="请输入图片地址">
          <template slot="append"
            ><span
              style="cursor: pointer"
              @click="selImg('guoDoctor', 'topImg')"
              >选择图片</span
            ></template
          >
        </el-input>
        <el-col :span="18">
          <img :src="curSelData.zsxx.topImg" alt="" class="imgClass" />
        </el-col>
      </el-form-item>
      <el-form-item label="一物一码图片">
        <el-input
          v-model="curSelData.zsxx.topImg2"
          placeholder="请输入图片地址"
        >
          <template slot="append"
            ><span
              style="cursor: pointer"
              @click="selImg('guoDoctor', 'topImg2')"
              >选择图片</span
            ></template
          >
        </el-input>
        <el-col :span="18">
          <img :src="curSelData.zsxx.topImg2" alt="" class="imgClass" />
        </el-col>
      </el-form-item>

      <el-form-item label="二维码背景">
        <el-input v-model="curSelData.scanBg" placeholder="请输入图片地址">
          <template slot="append"
            ><span
              style="cursor: pointer"
              @click="selImg('guoDoctor', 'scanBg')"
              >选择图片</span
            ></template
          >
        </el-input>
        <el-col :span="18">
          <img :src="curSelData.scanBg" alt="" class="imgClass" />
        </el-col>
      </el-form-item>
      <el-form-item label="校验说明背景图片">
        <el-input v-model="curSelData.codeBg" placeholder="请输入图片地址">
          <template slot="append"
            ><span
              style="cursor: pointer"
              @click="selImg('guoDoctor', 'codeBg')"
              >选择图片</span
            ></template
          >
        </el-input>
        <el-col :span="18">
          <img :src="curSelData.codeBg" alt="" class="imgClass" />
        </el-col>
      </el-form-item>
      <el-form-item label="校验说明数字颜色">
        <template>
          <bs-color-picker v-model="curSelData.zsxx.numColor" />
        </template>
      </el-form-item>
      <el-form-item label="校验说明文案颜色">
        <template>
          <bs-color-picker v-model="curSelData.zsxx.xxColor" />
        </template>
      </el-form-item>
      <el-form-item label="备注文案颜色">
        <template>
          <bs-color-picker v-model="curSelData.zsxx.remarkColor" />
        </template>
      </el-form-item>
      <el-form-item label="时间地点背景颜色">
        <template>
          <bs-color-picker v-model="curSelData.zsxx.infoBgColor" />
        </template>
      </el-form-item>
      <el-form-item label="时间地点文案颜色">
        <template>
          <bs-color-picker v-model="curSelData.zsxx.infoLabelColor" />
        </template>
      </el-form-item>
      <el-form-item label="时间地点值颜色">
        <template>
          <bs-color-picker v-model="curSelData.zsxx.infoValueColor" />
        </template>
      </el-form-item>

      <el-form-item label="校验框背景图片">
        <el-input v-model="curSelData.boxBg" placeholder="请输入图片地址">
          <template slot="append"
            ><span style="cursor: pointer" @click="selImg('guoDoctor', 'boxBg')"
              >选择图片</span
            ></template
          >
        </el-input>
        <el-col :span="18">
          <img :src="curSelData.boxBg" alt="" class="imgClass" />
        </el-col>
      </el-form-item>

      <el-form-item label="跳转控件">
        <template>
          <el-radio v-model="curSelData.zsxx.jumpStyle" :label="1"
            >显示</el-radio
          >
          <el-radio v-model="curSelData.zsxx.jumpStyle" :label="2"
            >不显示</el-radio
          >
        </template>
      </el-form-item>
      <!-- 验证码结束 -->
    </el-form>
  </div>
</template>
<script>
import BsSlider from "../module/BsSlider";
import BsColorPicker from "../module/BsColorPicker";
export default {
  components: {
    BsSlider,
    BsColorPicker,
  },
  props: {
    curSelData: {
      type: Object,
      default: () => {
        tabbar;
      },
    },
    fySelItem: {},
  },
  computed: {
    selIndex() {
      let index = 0;
      for (let i = 0; i < this.curSelData.tabbar.length; i++) {
        if (this.curSelData.tabbar[i].title === this.fySelItem.title) {
          index = i;
        }
      }
      return index;
    },
  },
  data() {
    return {};
  },
  mounted() {
    console.log(this.fySelItem);
  },
  methods: {
    addVideo() {
      this.curSelData.zsxx.videoList.push({
        time: "",
        desc: "",
        poster: "",
        video: "",
      });
    },
    delVideo(index) {
      this.curSelData.zsxx.videoList.splice(index, 1);
    },
    clearColor(attr) {
      this.curSelData[attr] = "transparent";
    },
    addItem() {
      const width = (100 / (this.curSelData.picList.length + 1)).toFixed(2);
      this.curSelData.picList.forEach((item) => {
        item.width = width + "%";
      });
      this.curSelData.picList.push({ width: width + "%", url: "" });
    },
    delPic(index) {
      const width = (100 / (this.curSelData.picList.length - 1)).toFixed(2);
      this.curSelData.picList.forEach((item) => {
        item.width = width + "%";
      });
      this.curSelData.picList.splice(index, 1);
    },

    // 选择图片
    selImg(type, attr, index) {
      this.$emit("selImg", type, attr, index);
    },
    // 证书信息
    delSItem(index, sIndex) {
      this.curSelData.zsxx.infoMain[index].siteList.splice(sIndex, 1);
    },
    addSItem(index, sIndex) {
      this.curSelData.zsxx.infoMain[index].siteList.push({
        siteInfo: [
          {
            name: "",
            value: "",
          },
        ],
      });
    },
    delSSItem(index, sIndex, ssIndex) {
      this.curSelData.zsxx.infoMain[index].siteList[sIndex].siteInfo.splice(
        ssIndex,
        1,
      );
    },
    addSSItem(index, sIndex) {
      this.curSelData.zsxx.infoMain[index].siteList[sIndex].siteInfo.push({
        name: "",
        value: "",
      });
    },
    addInfoMainOne() {
      this.curSelData.zsxx.infoMain.push({
        title: "·标题",
        msg: "内容",
        msgColor: "#1C3B9E",
        linkImg: "https://apkpic.86122m.com/mktpic/fangyuan/rk1.png",
        linkHref: "",
        type: 1,
        siteList: [
          {
            siteInfo: [
              {
                name: "名称",
                value: "内容",
              },
            ],
          },
        ],
      });
    },
    delInfoMainOne(index) {
      this.curSelData.zsxx.infoMain.splice(index, 1);
    },
    addLunboItem(index) {
      this.curSelData.zsxx.picList.push({
        url: "https://apkpic.86122m.com/mktpic/fangyuan/zsTest.png",
      });
    },
    delLunboItem(index) {
      this.curSelData.zsxx.picList.splice(index, 1);
    },
    addInfoMain2One(index) {
      this.curSelData.zsxx.infoMain2.push({
        box1: {
          title: "标题1",
          msg: "内容1",
          msgColor: "#2E3033",
        },
        box2: {
          title: "标题2",
          msg: "内容2",
          msgColor: "#2E3033",
        },
      });
    },
    delInfoMain2One(index) {
      this.curSelData.zsxx.infoMain2.splice(index, 1);
    },
    addPhotoItem() {
      this.curSelData.xchy.photoList.push({
        url: "",
      });
    },
    delPhotoItem(index) {
      this.curSelData.xchy.photoList.splice(index, 1);
    },
    addTx() {
      this.curSelData.txjs.listData.push({
        name: "标题",
        nameEng: "英文标题",
        numImg: "https://apkpic.86122m.com/mktpic/fangyuan/number01.png",
        type: 1,
        content: "内容",
      });
    },
    delTx(index) {
      this.curSelData.txjs.listData.splice(index, 1);
    },
    addGy() {
      this.curSelData.gyfy.listData.push({
        name: "标题",
        nameEng: "英文标题",
        type: 1,
        content: "内容",
      });
    },
    delGy(index) {
      this.curSelData.gyfy.listData.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.imgClass {
  margin-top: 10px;
}

.pageTitle {
  color: #20a0ff;
  font-weight: bold;
  text-align: center;
  padding: 10px 0;
}

.pageTitle2 {
  border-top: 1px solid #20a0ff;
}
.imgClass {
  width: 200px;
  height: auto;
  margin: 15px 0;
}
.flexEnd {
  display: flex;
  justify-content: flex-end;
}
</style>
